var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAccountManager)?_c('div',{staticClass:"fixpos"},[_c('div',{staticClass:"ximuserve"},[_c('div',{staticClass:"serveinner",on:{"click":_vm.chatWithCustomerService}},[_c('div',{staticClass:"iconfont iconserve"},[_vm._v("")]),_vm._v(" "),_c('div',[_vm._v("客服")])])]),_vm._v(" "),_c('xmAccountManager')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }